export default function StatCard({ label, value, detail }) {
  return (
    <div className="rounded-md border border-civic-line bg-white p-5 shadow-sm">
      <div className="text-2xl font-black text-civic-navy">{value}</div>
      <div className="mt-1 text-sm font-semibold text-slate-800">{label}</div>
      {detail && <div className="mt-2 text-xs leading-5 text-slate-500">{detail}</div>}
    </div>
  );
}
